var $ = require("jquery");
var core_blocks = [];

$(".wp-block-media-text").each(function() {
    $(this).children().wrapAll('<div class="container-sm media-text__container"></div>');
})